var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-divider',[_c('svg-icon',{attrs:{"icon-class":"mine_icon_love"}}),_vm._v(" "+_vm._s(_vm.title)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }